import { render } from "./LanguageSelectionView.vue?vue&type=template&id=75fd69b0&ts=true"
import script from "./LanguageSelectionView.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__